import React from "react";
import { Box, TextField } from "@mui/material";
import { useMediaQuery } from "@mui/material";

import BoutonAjouterContact from "./BoutonAjouterContact.js";
import ImportContactsMobile from "../components/ImportContactsMobile.js";

import PhoneInput from "./common/PhoneInput.js";

import { isValidPhone, buildFullNumber } from "../utils/phoneUtils.js";

const AddContactForm = ({ t, newContact, setNewContact, handleAdd, handleContactsSelected }) => {
  
  const isMobile = useMediaQuery("(max-width:600px)");
  const isAndroid = /Android/i.test(navigator.userAgent);
  const showMobileImport = isMobile && isAndroid;

  // ⚠️ on ne stocke que le numéro brut
  const handlePhoneChange = (e) => {
    const raw = e.target.value.replace(/\D/g, "");
    setNewContact({ ...newContact, numero: raw });
  };

  // ⚠️ validation sur le numéro complet
  const fullNumber = buildFullNumber(newContact.indicatif, newContact.numero);
  const erreurTel =
    newContact.numero?.trim() && !isValidPhone(fullNumber)
      ? t("InvalidPhoneFormat")
      : "";

  return (
    <>

    {showMobileImport && (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginBottom: 2
        }}
      >
        <ImportContactsMobile
          onContactsSelected={handleContactsSelected}
          isMobile={isMobile}
          t={t}
        />
      </Box>
  )}
  
      <Box
        className="add-contact-container"
        sx={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: 2,
          alignItems: "stretch",
          mb: 2
        }}
      >
        <TextField
          required
          className="textfield-add"
          label={t("Name")}
          value={newContact.nom}
          onChange={(e) => setNewContact({ ...newContact, nom: e.target.value })}
        />

        <PhoneInput
          indicatif={newContact.indicatif}
          setIndicatif={(val) => setNewContact({ ...newContact, indicatif: val })}
          numero={newContact.numero}
          setNumero={(val) => setNewContact({ ...newContact, numero: val })}
          erreurTel={erreurTel}
          t={t}
          sx={{
            flex: 1,
            minWidth: isMobile ? "100%" : "250px"
          }}
        />

        <TextField
          className="textfield-add"
          label={t("Email")}
          type="email"
          value={newContact.mail}
          onChange={(e) => setNewContact({ ...newContact, mail: e.target.value })}
          sx={{ flex: 2, minWidth: isMobile ? "100%" : "300px" }}
        />
      </Box>

      <Box
        sx={{
          width: "100%",
          marginTop: 2,
          display: "flex",
          justifyContent: "center",
          gap: 2,
          flexWrap: "wrap"
        }}
      >
        <BoutonAjouterContact
          type="button"
          label={t("AddContact")}
          onClick={handleAdd}
          disabled={
            !newContact.nom.trim() ||
            (newContact.numero?.trim() &&
              !isValidPhone(buildFullNumber(newContact.indicatif, newContact.numero)))
          }
        />

      </Box>
    </>
  );
};

export default AddContactForm;
